export default "__VITE_ASSET__g6S8Vzd9__";